import React, { useState } from 'react';
// import Jspdf from 'jspdf';

import { Typography, Input } from 'antd';
// import certificate001 from '../components/other/certificate001';
// import dancing from '../components/other/font-dancing';
// import gothic from '../components/other/font-gothic';
// import century from '../components/other/font-century';
// import React, { useState, useEffect, useCallback } from 'react';
// import { useRouter } from 'next/router';
// import SectionHeader from '../../components/SectionHeader';
// import decodeProfile from '../../utils/decode_profile';
// import NumberCard from '../../utils/number';
// import dataService from '../services/data';
// import { TCompetition } from '../../types/competition';

// const IS_BROWSER = typeof window !== 'undefined';
// const userType = IS_BROWSER ? (decodeProfile() || { type: 0 }).type : 0;

// type TSummaryResult = { count: number; competition?: number };

// type ResultRow = {
//     grade: number;
//     level: number;
//     index: string;
//     name: string;
//     marks: number;
//     medium: string;
//     school: string;
// };

// const toTitleCase = (text: string): string => {
//     const adjustedText = text.replace(/\./g, '. ').replace(/\s\s/g, ' ');
//     const str = adjustedText.replace(/([^\W_]+[^\s-]*) */g, (txt: string) => {
//         return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
//     });
//     return str;
// };
const { Title } = Typography;

const certificates = [
    'https://slomf.s3.ap-southeast-1.amazonaws.com/certs/slmo-certificates-2018/5.%20APMO_%202019/GHAURA%20ABHEENDRA%20MAHABADUGE.pdf',
    'https://slomf.s3.ap-southeast-1.amazonaws.com/certs/slmo-certificates-2018/5.%20APMO_%202019/MANETH%20BANULA%20PERERA.pdf',
    'https://slomf.s3.ap-southeast-1.amazonaws.com/certs/slmo-certificates-2018/5.%20APMO_%202019/MIHIRU%20ANUSHKA%20BANDARA.pdf',
    'https://slomf.s3.ap-southeast-1.amazonaws.com/certs/slmo-certificates-2018/5.%20APMO_%202019/NELUSHI%20VITHANACHCHI.pdf',
    'https://slomf.s3.ap-southeast-1.amazonaws.com/certs/slmo-certificates-2018/5.%20APMO_%202019/SHENAL%20SANTHUSH%20KOTUWEWATTA.pdf',
    'https://slomf.s3.ap-southeast-1.amazonaws.com/certs/slmo-certificates-2018/5.%20APMO_%202019/UDITHA%20SANDARUWAN%20WIJERATNE.pdf',
];

const certificateBase = 'https://slomf.s3.ap-southeast-1.amazonaws.com/certs/slmo-certificates-2018/5.%20APMO_%202019/';

const Certificates = (): JSX.Element => {
    const [searchText, setSearchText] = useState('');
    const getList = (): JSX.Element | null => {
        if (searchText.length < 3) {
            return (
                <>
                    {certificates.map(certificate => {
                        const name = certificate
                            .replace(certificateBase, '')
                            .replace('.pdf', '')
                            .replace(/%20/g, ' ');
                        return (
                            <>
                                <a href={certificate} key={certificate} target="blank">
                                    {name}
                                </a>
                                <br />
                            </>
                        );
                    })}
                </>
            );
        }
        const filteredCerts = certificates.filter(certificate => {
            const name = certificate
                .replace(certificateBase, '')
                .replace('.pdf', '')
                .replace(/%20/g, ' ');
            return name.toLowerCase().includes(searchText.toLowerCase());
        });
        return (
            <>
                {filteredCerts.map(certificate => {
                    const name = certificate
                        .replace(certificateBase, '')
                        .replace('.pdf', '')
                        .replace(/%20/g, ' ');
                    return (
                        <>
                            <a href={certificate} key={certificate} target="blank">
                                {name}
                            </a>
                            <br />
                        </>
                    );
                })}
            </>
        );
    };
    return (
        <>
            {/* <Typography>Test</Typography>
            <Button onClick={(): void => {}}>Test1</Button> */}
            <Title level={4}>APMO 2019 Certificates</Title>
            <Title level={5}>Start entering your surname to search</Title>
            <Input
                value={searchText}
                onChange={(event): void => {
                    setSearchText(event.target.value);
                }}
            />
            <hr />
            {getList()}
        </>
    );
};

export default Certificates;
